export default __webpack_public_path__ + "static/media/constipation@2x.3ddc058b.jpg";